import "@/App.css";
import Navbar from "@/components/landing/Navbar";
import HeroSection from "@/components/landing/HeroSection";
import ProblemSection from "@/components/landing/ProblemSection";
import CalculatorSection from "@/components/landing/CalculatorSection";
import HowItWorks from "@/components/landing/HowItWorks";
import ResultsSection from "@/components/landing/ResultsSection";
import PricingSection from "@/components/landing/PricingSection";
import TestimonialsSection from "@/components/landing/TestimonialsSection";
import TeamSection from "@/components/landing/TeamSection";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

function App() {
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navbar />
      <HeroSection />
      <ProblemSection />
      <CalculatorSection />
      <HowItWorks />
      <ResultsSection />
      <PricingSection />
      <TestimonialsSection />
      <TeamSection />
      <FinalCTA />
      <Footer />
    </div>
  );
}

export default App;
